function nextSlice(callback) {
  /* istanbul ignore next */
  Promise.resolve().then(callback);
}
export { nextSlice };
//# sourceMappingURL=timeUtil.js.map
